import { Route } from 'vue-router';

import DirectSalesProposalsPage from '@/modules/direct-sales/pages/direct-sales-proposals/direct-sales-proposals.page.vue';
import DirectSalesDashBoard from '@/modules/direct-sales/pages/direct-sales-dashboard/direct-sales-dashboard.page.vue';
import DirectSalesProposalsCreatePage from '@/modules/direct-sales/pages/direct-sales-proposals-create/direct-sales-proposals-create.page.vue';
import DirectSalesProposalsSetupPage from '@/modules/direct-sales/pages/direct-sales-proposals-setup/direct-sales-proposals-setup.page.vue';
import DirectSalesProposalsCompletePage from '@/modules/direct-sales/pages/direct-sales-proposals-complete/direct-sales-proposals-complete.page.vue';
import DirectSalesProposalsAvailability from '@/modules/direct-sales/pages/direct-sales-proposals-availability/direct-sales-proposals-availability.page.vue';
import DirectSalesHistoricClient from '@/modules/direct-sales/pages/direct-sales-historic-client/direct-sales-historic-client.page.vue'
import DirectSalesClients from '@/modules/direct-sales/pages/direct-sales-list-clients/direct-sales-list-clients.vue'

export const DIRECT_SALES_ROUTES = Object.freeze({
  DASHBOARD: 'direct-sales-dashboard-page',
  PROPOSALS: 'direct-sales-proposals-page',
  PROPOSALS_CREATE: 'direct-sales-proposals-create-page',
  PROPOSALS_AVAILABILITY: 'direct-sales-proposals-availability',
  PROPOSALS_SETUP: 'direct-sales-proposals-setup-page',
  PROPOSALS_COMPLETE: 'direct-sales-proposals-complete-page',
  HISTORIC_CLIENT: 'historic-client',
  LIST_CLIENTS: 'list-clients'
});

const basePath: string = '/direct-sales';

export const directSalesRoutes = [
  {
    path: `${basePath}/`,
    component: DirectSalesDashBoard,
    name: DIRECT_SALES_ROUTES.DASHBOARD
  },
  {
    path: `${basePath}/proposals`,
    component: DirectSalesProposalsPage,
    name: DIRECT_SALES_ROUTES.PROPOSALS
  },
  {
    path: `${basePath}/proposals/create/`,
    component: DirectSalesProposalsCreatePage,
    name: DIRECT_SALES_ROUTES.PROPOSALS_CREATE,
    props: (route: Route) => ({
        proposalId:  Number(route.params.proposalId),
        search: String(route.params.search),
        idGroup: Number(route.params.idGroup),
        idStore: Number(route.params.idStore)
      })
  },
  {
    path: `${basePath}/proposals/availability/:consumerId/`,
    component: DirectSalesProposalsAvailability,
    name: DIRECT_SALES_ROUTES.PROPOSALS_AVAILABILITY,
    props: (route: Route) => ({
      consumerId: Number(route.params.consumerId),
      proposalId:  Number(route.params.proposalId)
    })
  },
  {
    path: `${basePath}/proposals/setup/:consumerId`,
    component: DirectSalesProposalsSetupPage,
    name: DIRECT_SALES_ROUTES.PROPOSALS_SETUP,
    props: (route: Route) => ({
      consumerId: Number(route.params.consumerId),
      modelSelected: route.params.modelSelected,
      proposalId:  Number(route.params.proposalId)
    })
  },
  {
    path: `${basePath}/proposals/complete/:proposalId/:consumerId`,
    component: DirectSalesProposalsCompletePage,
    name: DIRECT_SALES_ROUTES.PROPOSALS_COMPLETE,
    props: (route: Route) => ({
      proposalId: Number(route.params.proposalId),
      consumerId: Number(route.params.consumerId),
      showProgress: Number(route.params.showProgress)
    })
  },
  {
    path: `${basePath}/historic/client/:consumerId`,
    component: DirectSalesHistoricClient,
    name: DIRECT_SALES_ROUTES.HISTORIC_CLIENT,
    props: (route: Route) => ({
      consumerId: Number(route.params.consumerId),
      proposalId: Number(route.params.proposalId),
      search: String(route.params.search)
    })
  },
  {
    path: `${basePath}/list-clients`,
    component: DirectSalesClients,
    name: DIRECT_SALES_ROUTES.LIST_CLIENTS,
    props: (route: Route) => ({
        idGroup: Number(route.params.idGroup),
        idStore: Number(route.params.idStore)
    })
  }
];
